<template>
  <v-dialog :value="isModalActive" max-width="500" @input="inputModal">
    <v-card
      id="keep-free-reason-modal-card"
      class="pb-1 pt-6 pr-2"
      :color="$vuetify.theme.dark ? 'dark_backgroundDarkBlue' : undefined"
    >
      <v-card-text class="pb-0 mb-0 pt-0">
        <div class="keep-free-reason-modal-card-text">
          {{ $t('views.common.upgradeModal.planCard.keepFreeReason.title') }}
        </div>
        <div class="keep-free-reason-modal-card-options">
          <v-radio-group v-model="reason">
            <v-radio
              :label="$t('views.common.upgradeModal.planCard.keepFreeReason.features')"
              value="features"
            ></v-radio>
            <template v-if="reason === 'features'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.common.upgradeModal.planCard.keepFreeReasonText.features`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
            <v-radio
              :label="$t('views.common.upgradeModal.planCard.keepFreeReason.lost')"
              value="lost"
            ></v-radio>
            <template v-if="reason === 'lost'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.common.upgradeModal.planCard.keepFreeReasonText.lost`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
            <v-radio
              :label="$t('views.common.upgradeModal.planCard.keepFreeReason.price')"
              value="price"
            ></v-radio>
            <template v-if="reason === 'price'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.common.upgradeModal.planCard.keepFreeReasonText.price`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
            <v-radio
              :label="$t('views.common.upgradeModal.planCard.keepFreeReason.other')"
              value="other"
            ></v-radio>
            <template v-if="reason === 'other'">
              <v-textarea
                v-model="otherText"
                filled
                :label="$t(`views.common.upgradeModal.planCard.keepFreeReasonText.other`)"
                auto-grow
                class="mb-3 pa-0"
                hide-details
                rows="2"
                maxlength="1500"
              ></v-textarea>
            </template>
          </v-radio-group>
        </div>
      </v-card-text>
      <v-card-actions class="mt-0 pt-0">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="saveDisabled"
          :loading="loading"
          @click="createKeepFreeReason"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalMixin from '@/views/components/core/modalMixin.js'
import { createKeepFreeReason } from '@/lib/api'
import gtag from '@/lib/gtag'

export default {
  mixins: [modalMixin],
  data: () => ({
    loading: false,
    reason: null,
    otherText: null,
  }),
  computed: {
    saveDisabled() {
      return !this.reason || !this.otherText || this.otherText === ''
    },
  },
  methods: {
    resetForm() {
      this.reason = null
      this.otherText = null
    },
    async createKeepFreeReason() {
      this.loading = true

      try {
        const reason = this.reason
        const text = this.otherText ? this.otherText : undefined
        await createKeepFreeReason({
          reason,
          text,
        })

        gtag.pageview({
          pagePath: `/account/billing/upgrade/keepFreeReason/success`,
          pageTitle: `account|billing|upgrade|keepFreeReason|success`,
          pageContentGroup: 'modal',
        })

        this.closeModal()
        this.$emit('closeParentModal')
      } catch (error) {
        this.$root.$snackbar.error({ text: this.$t('common.saveError') })
      }
      this.loading = false
    },
  },
}
</script>

<style lang="scss">
#keep-free-reason-modal-card {
  .keep-free-reason-modal-card-text {
    font-size: 15px;
  }
  .keep-free-reason-modal-card-options {
    .v-label {
      color: black;
    }
    .v-label.theme--dark {
      color: #a5a5a5;
    }
  }
}
</style>
